import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import styles from "../../stripe-dashboard.module.css";

registerLocale("pt-BR", ptBR);

function DashboardFilters({ selectedMonth, onMonthChange }) {
  return (
    <div className={styles.filterRow}>
      <label className={styles.filterLabel}>Filtrar por mês</label>
      <DatePicker
        selected={selectedMonth}
        onChange={date => onMonthChange(date)}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        locale="pt-BR"
      />
    </div>
  );
}

export default DashboardFilters;
